export type RemoteVersionInfo = {
  version: string;
  buildTime: string;
};

export const fetchRemoteVersion = async (): Promise<RemoteVersionInfo | null> => {
  try {
    const baseUrl = process.env.PUBLIC_URL || "";
    const response = await fetch(`${baseUrl}/version.json?_=${Date.now()}`, {
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });

    if (!response.ok) return null;
    return response.json();
  } catch {
    return null;
  }
};

export const isRemoteVersionNewer = (
  remote: RemoteVersionInfo,
  localVersion: string,
  localBuildTime: string
) => remote.version !== localVersion || remote.buildTime !== localBuildTime;
